import React from "react";
import { Button, Col, Row } from "antd";
import { OurStoryTeam } from "../../../helperFunction";
import "./styles.scss";

const OurTeam = () => {
  return (
    <section className="story-page-team">
      <Row className="team-content">
        {OurStoryTeam?.map((e) => {
          return (
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={8}
              xl={8}
              xxl={8}
              className="team-member-card"
            >
              <img src={e?.profileImg} className="team-member-img" alt="#" />
              <div className="member-name">{e?.name}</div>
              <div className="member-designaton">{e?.designation}</div>
            </Col>
          );
        })}
      </Row>
      <Button style={{ width: 230 }} className="more-games-btn" href="/careers">
        Join Us
      </Button>
    </section>
  );
};

export default OurTeam;
